<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['order.no']" :placeholder="$t('placeholder.receiptOrderNo')" class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['commandId']" :placeholder="$t('business.label.commandId')" class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['storageRoom.name']" :placeholder="$t('business.label.storageRoom')" class="query" readOnly @dblclick="()=>this.$refs.storageRoomModal.open()" @pressEnter="search" @search="()=>this.$refs.storageRoomModal.open()"/>
      <a-input-search v-model="query['zone.name']" :placeholder="$t('business.label.zone')" class="query" readOnly @dblclick="()=>this.$refs.zoneModal.open({'storageRoom.name':this.query['storageRoom.name']})" @pressEnter="search"
                      @search="()=>this.$refs.zoneModal.open({'storageRoom.name':this.query['storageRoom.name']})"/>
      <a-date-picker v-model="query.commandDateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('business.label.startTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.commandDateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('business.label.endTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
    </a-space>
    <a-space>
      <a-input-search v-model="query['item.no']" :placeholder="$t('business.label.itemNo')" class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['item.name']" :placeholder="$t('business.label.itemName')" class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['item.mnemonicCode']" :placeholder="$t('business.label.mnemonicCode')" class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['lot.no']" :placeholder="$t('business.label.lot')" class="query" @pressEnter="search" @search="search"/>
    </a-space>
    <storage-room-modal ref="storageRoomModal" @change="setStorageRoom"/>
    <zone-modal ref="zoneModal" @change="setZone"/>
    <shelf-task ref="shelfTask" :scroll-y="scrollY"/>
  </a-layout>
</template>

<script>
  import moment from 'moment'
  import PageUtil from '@/components/Pagination/PageUtil.vue'
  import {findAll} from '@/api/Api'
  import ShelfTask from '@/views/inbound/shelf/ShelfTask.vue'
  import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
  import ZoneModal from '@/views/modal/ZoneModal.vue'
  import Vue from 'vue'
  import {SCREEN_HEIGHT} from '@/store/mutation-types'

  export default {
    name: 'ShelfByArgs',
    components: {ZoneModal, StorageRoomModal, ShelfTask, PageUtil},
    data() {
      return {
        selectedRowKeys: [],
        selectedRows: [],
        data: [],
        storerData: [],
        orderStatusData: [],
        contentSize: 0,
        page: 1,
        size: 5,
        loading: false,
        query: {
          'order.no': '',
          commandId: '',
          commandDateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'lot.no': '',
          'storageRoom.name': '',
          'zone.name': ''
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.735),// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    mounted() {
      findAll('storerFactory', {available: true}).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
    },
    methods: {
      moment,
      disabledStartDate(startValue) {
        const endValue = this.query.commandDateFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.commandDateFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      setStorageRoom(storageRoomData) {
        if (storageRoomData.length !== 0) {
          let sr = storageRoomData[0]
          this.query['storageRoom.name'] = sr.name
          this.query['zone.name'] = null
        } else {
          this.query['storageRoom.name'] = null
          this.query['zone.name'] = null
        }
      },
      setZone(zoneData) {
        if (zoneData.length !== 0) {
          let zone = zoneData[0]
          this.query['zone.name'] = zone.name
        } else {
          this.query['zone.name'] = null
        }
      },
      search() {
        this.$refs.shelfTask.search(this.query)
      },
      reset() {
        this.query = {
          'order.no': '',
          commandId: '',
          commandDateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'lot.no': '',
          'storageRoom.name': '',
          'zone.name': ''
        }
        this.$refs.shelfTask.reset()
      },
      confirm() {
        this.$refs.shelfTask.putaway()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 200px;
  }
</style>